import { render, staticRenderFns } from "./subscriptionSettlement.vue?vue&type=template&id=854e9fda&scoped=true"
import script from "./subscriptionSettlement.vue?vue&type=script&lang=js"
export * from "./subscriptionSettlement.vue?vue&type=script&lang=js"
import style0 from "./subscriptionSettlement.vue?vue&type=style&index=0&id=854e9fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854e9fda",
  null
  
)

export default component.exports